'use client';

import { Flex, Box } from '@chakra-ui/react';
import { ColorModeButton } from '@/components/ui/color-mode';
import Image from 'next/image';
import { useContext, useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { AuthContext } from '@/contexts/AuthContext';
import UserMenu from '../UserMenu';
import SearchBar from '../Search';
import LeftMenu from '../LeftMenu';
import Cart from '../Cart';

const MainMenu: React.FC = () => {
  const { setRefererCookies } = useContext(AuthContext);

  const { push } = useRouter();

  useEffect(() => {
    if (document.referrer) setRefererCookies(document.referrer);
  }, [setRefererCookies]);

  return (
    <Flex
      width="full"
      justify="center"
      align="center"
      position="fixed"
      top="0px"
      left="0"
      right="0"
      zIndex="998"
      bg={{
        base: 'rgba(255,255,255,0.98)',
        _dark: 'rgba(5,12,22,0.98)',
      }}
      backdropFilter="blur(28px) saturate(200%)"
    >
      {/* Bottom gradient glow line */}
      <Box
        pos="absolute"
        bottom="0"
        left="0"
        right="0"
        h="1px"
        bgGradient="linear(to-r, transparent, rgba(0,176,202,0.35) 30%, rgba(0,176,202,0.5) 50%, rgba(0,176,202,0.35) 70%, transparent)"
      />

      <Flex
        justify="space-between"
        width="100%"
        maxW="breakpoint-xl"
        pos="relative"
        h={{ base: '62px', md: '70px' }}
        px={{ base: '10px', md: '24px' }}
        align="center"
        gap={{ base: '8px', md: '16px' }}
      >
        {/* Left: Hamburger + Logo */}
        <Flex align="center" gap={{ base: '0px', md: '6px' }} flexShrink={0}>
          <LeftMenu />
          <Box
            cursor="pointer"
            onClick={() => push('/')}
            w={{ base: '114px', md: '140px' }}
            flexShrink={0}
            transition="opacity 0.22s"
            _hover={{ opacity: 0.75 }}
          >
            <Image
              src='/ido-logo.png'
              alt="Logo idO"
              width={90}
              height={50}
              quality={100}
              priority
            />
          </Box>
        </Flex>

        {/* Center: Search — grows to fill available space */}
        <Flex flex="1" maxW={{ base: '100%', md: '520px' }}>
          <SearchBar />
        </Flex>

        {/* Right: Actions in a grouped pill */}
        <Flex
          align="center"
          gap="0"
          flexShrink={0}
          bg={{ base: 'rgba(0,0,0,0.03)', _dark: 'rgba(255,255,255,0.05)' }}
          borderRadius="full"
          border="1px solid"
          borderColor={{ base: 'rgba(0,0,0,0.07)', _dark: 'rgba(255,255,255,0.07)' }}
          px="2px"
          py="2px"
        >
          <ColorModeButton />
          <UserMenu />
          <Cart />
        </Flex>
      </Flex>
    </Flex>
  );
};

export default MainMenu;
